/*
 * Makes a call to the blob store to upload the image pixels.
 * @sig uploadPixels :: (Image, String, String, JWT) -> ()
 */
const uploadPixels = async image => {
    return Promise.resolve(image.id);
};

const getBlob = async () => {
    return Promise.resolve('https://img.locuslabs.com/poi/IMG_20170118_143646.jpg');
};

const MockBlob = {
    uploadPixels,
    getBlob,
};

export { MockBlob };
